export default __webpack_public_path__ + "web/src/assets/images/embed/framework_logos/ionic.svg?[fullhash]";